export var SECTION_COLORS = {
  NeutralBackground1Level: 'neutral-background1-level',
  NeutralBackground: 'neutral-background'
};